import { SELF_SERVICE_ORIGIN, SELF_SERVICE_TYPE } from 'constants/SelfServiceConstants';
import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../actionTypes';

/** @typedef {import('../../../types').SelfServiceDetailsFilters} State */

/** @type {State} */
const initialState = { type: SELF_SERVICE_TYPE.CHECK_IN, origin: SELF_SERVICE_ORIGIN.HOME, groupBy: undefined };

/**
 * @param {State} state
 * @param {import('../../../types').SetDetailsStatsSelfServiceFiltersAction} action
 * @return {State}
 */
const setFilters = (state, { payload }) => ({
  ...state,
  ...payload,
});

export default createReducer(initialState, {
  [types.SET_DETAILS_STATS_SELF_SERVICE_FILTERS]: setFilters,
});
